<template>
    <div class="loader-page">
        <div class="loader-bar"></div>
        <div class="inner">
            <img src="../assets/img/logo2.png" alt="">
            <p>Loading <span class="load-ball"></span></p>
        </div>
    </div>
</template>